export const UPDATE_TIME_CARD_STATUS = `
  mutation ($token: String!, $id: ID!, $status: String!) {
    updateTimeCardStatus(timeCardStatus: {token: $token, id: $id, status: $status}) {
      data 
      error {
        code
        message
        statusCode
      }
    }
  }
`
